
import { clientFunction } from '../../../config/apollo/client';

import { GET_CURRENT_RECKONING, GET_PUBLIC_RECKONING, GET_RECKONING } from '../../queries/Reckonings';
import { ReckoningModel } from './ReckoningModel';
import { flow, getParent, types } from 'mobx-state-tree';


export const ReckoningStore = types
  .model('ReckoningStore', {
    reckoning: types.array(types.maybeNull(ReckoningModel)),
    state: types.maybe(types.enumeration(['pending', 'done', 'error'])),
  })
  .actions(self => {
    const getCurrentReckoning= flow(function* (language) {
      try {
        const { data }: any = yield clientFunction(language).query({ query: GET_CURRENT_RECKONING,
          fetchPolicy: 'no-cache'  });
        if (data && data.currentReckoning && data.currentReckoning._id) {
          data.currentReckoning.alreadyDone = false;
          loadReckoning(data.currentReckoning, true);
        } else {
          self.reckoning = [];
        }
      } catch(error) {
        console.log('error in fetch current reckoning',error);
      }
    });
    const fetchReckoning= flow(function* (id, publik = false) {
      // Central guard: querying with no id is always a 500 from the API
      // ("No ID provided for retrieve actionReckoningService"), never a useful call.
      if (!id) return undefined;
      self.state = 'pending';
      try {
        const { data }: any = yield clientFunction((getParent(self) as any).language.name.key).query(
          { query: publik? GET_PUBLIC_RECKONING:GET_RECKONING,
            variables: {
              id
            },
            fetchPolicy: 'no-cache'  });
        const key = publik?'retrievePublicReckoning':'reckoning';
        if (data && key in data && data[key]._id) {
          loadReckoning(data[key], !data[key]?.alreadyDone);
        }
        self.state = 'done';
        return data[key];
      } catch(error) {
        self.state = 'error';
        console.log('error in fetch reckoning',error);
      }
    });
    const fetchReckoningIfNotExist= flow(function* (id, publik) {
      if (!id) return undefined;
      if (self.reckoning) {
        const index = self.reckoning.findIndex(r => r && r._id === id);
        if (index === -1) {
          return yield fetchReckoning(id, publik);
        } else {
          return self.reckoning[index];
        }
      }
    });
    const loadReckoning = (reckoningData: any, inDashboard: boolean) => {
      const index = self.reckoning?.findIndex(c => c._id === reckoningData._id);
      const reckoning = {...reckoningData,
        session:reckoningData?.session?._id,
        inDashboard};
      if (index === -1) {
        self.reckoning?.push(reckoning);
      } else {
        self.reckoning[index] = reckoning;
      }
    };

    const setDone = (reckoningId : string) => {
      const index = self.reckoning?.findIndex(r => r._id === reckoningId);
      if(index !== -1) {
        self.reckoning[index] = {...self.reckoning[index], alreadyDone: true, inDashboard: false};
      }
    };

    const clear = () => {
      self.reckoning = [];
    };


    return {
      getCurrentReckoning,
      fetchReckoning,
      fetchReckoningIfNotExist,
      loadReckoning,
      clear,
      setDone
    };
  })
  .views(self => ({
    getReckoning(id: string) {
      const index = self.reckoning.findIndex(p => p && p._id === id);
      if (index === -1) {
        return null;
      } else {
        return self.reckoning[index];
      }
    },
    getReckoningInDashboard() {
      const index = self.reckoning.findIndex(p => p && p.inDashboard);
      if (index === -1) {
        return null;
      } else {
        return self.reckoning[index];
      }
    },
  }));
